import type { ReactNode } from 'react';

import { Button } from '@/components/ui/Button';

import { cn } from '@/utils/cn';



export interface EmptyStateProps {

  title: string;

  description?: string;

  actionLabel?: string;

  onAction?: () => void;

  secondaryActionLabel?: string;

  onSecondaryAction?: () => void;

  icon?: ReactNode;

  className?: string;

  compact?: boolean;

}



export function EmptyState({

  title,

  description: _description,

  actionLabel,

  onAction,

  secondaryActionLabel,

  onSecondaryAction,

  icon,

  className,

  compact,

}: EmptyStateProps) {

  return (

    <div

      className={cn(

        'flex flex-col items-center justify-center rounded-xl border border-dashed border-slate-200 bg-slate-50/50 text-center dark:border-slate-700 dark:bg-slate-900/30',

        compact ? 'px-4 py-8' : 'px-6 py-12',

        className,

      )}

    >

      {icon && <div className="mb-3 text-slate-400 dark:text-slate-500">{icon}</div>}

      <h3 className="text-sm font-semibold text-slate-900 dark:text-slate-100">{title}</h3>

      {(actionLabel || secondaryActionLabel) && (

        <div className="mt-5 flex flex-wrap items-center justify-center gap-2">

          {actionLabel && onAction && (

            <Button type="button" size="sm" onClick={onAction}>

              {actionLabel}

            </Button>

          )}

          {secondaryActionLabel && onSecondaryAction && (

            <Button type="button" size="sm" variant="secondary" onClick={onSecondaryAction}>

              {secondaryActionLabel}

            </Button>

          )}

        </div>

      )}

    </div>

  );

}


